import { Breadcrumb, Col, DatePicker, Form, Row, Select, Spin, Tooltip } from 'antd'
import { Trans, useTranslation } from "react-i18next";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import React from 'react'
import { t } from 'i18next';
import { Link } from 'react-router-dom';

const SiteWiseOrderReport = () => {
    const { t } = useTranslation();
    const colors = ["#094E8F"];
    return (
        <>
            <div className="ListingTopBar">
                <div className="pagenamewrap">
                    <div className="pagename">
                        <Tooltip
                            color={colors}
                            placement="right"
                            title={
                                <span style={{ color: "#fff" }}>
                                    Interact with the visualizations to drill down into specific data points or
                                    filter results dynamically for deeper insights.
                                </span>
                            }
                        >
                            <h3>Site Wise Order Report</h3>
                        </Tooltip>

                        <Breadcrumb className="Breadcrumb-Sec">
                            <Breadcrumb.Item>
                                <Link to="/dashboard">{t("home")}</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                Reports
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>Site Wise Order Report</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </div>
            </div>

            <div>
                <section className="grid-sec FormSection Container">
                    <div className="FormBody">

                        <Row gutter={[16]}>

                            <Col
                                xs={24}
                                sm={24}
                                md={12}
                                lg={6}
                                xl={6}
                                className="TextFeild gutter-row"
                            >
                                <Form.Item name="joining_date" label="Date">
                                    <DatePicker
                                        showTime
                                        format="DD-MM-YYYY"
                                    // onChange={(date, dateString) =>
                                    //     handleDatepickerChange(date, dateString, "joining_date")
                                    // }
                                    // value={
                                    //     state.joining_date
                                    //         ? moment(state.joining_date, "DD-MM-YYYY")
                                    //         : null
                                    // }
                                    />
                                </Form.Item>
                            </Col>

                            <Col
                                xs={24}
                                sm={24}
                                md={12}
                                lg={6}
                                xl={6}
                                className="TextFeild gutter-row"
                            >
                                <Form.Item
                                    name='vendor'
                                    label="Vendor"
                                    className="cust-selectBox"
                                // rules={[
                                //     {
                                //         required: true,
                                //         message: (
                                //             <Trans>
                                //                 {t("val_category_wise_WBS_number")}
                                //             </Trans>
                                //         ),
                                //     },
                                // ]}
                                >
                                    <Select
                                        showArrow
                                        showSearch
                                        allowClear
                                        placeholder="Select Vendor"
                                        optionFilterProp="children"

                                    // onChange={(value) =>
                                    //     handleCloneSelectChange(
                                    //         "category",
                                    //         value,
                                    //         index
                                    //     )
                                    // }
                                    >
                                        {/* {categoryTree &&
                        categoryTree.length > 0 &&
                        categoryTree.map((item) => (
                            <Select.Option
                                key={item.id}
                                value={item.id}
                            >
                                {item.name}
                            </Select.Option>
                        ))} */}
                                    </Select>
                                </Form.Item>
                            </Col>

                        </Row>

                    </div>
                </section>
            </div>
        </>
    )
}

export default SiteWiseOrderReport